<template>
    <div class="sidebar">
          <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="#303133"
            text-color="#ffffff"
            active-text-color="#ffd04b"
            unique-opened
            router
        >
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-school"></i>
                <span slot="title">厂测统计</span>
              </template>
              <el-menu-item index="/ModelTotal">总体统计</el-menu-item>
              <el-menu-item index="/DateTotal">时间统计</el-menu-item>
              <el-menu-item index="/Personnel">员工统计</el-menu-item>
              <el-menu-item index="/Trend">趋势统计</el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>

<script>
export default {
  data () {
    return {
      collapse: false,
    };
  },
  computed: {

    
  },
  created () {
    
  }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 60px;
    bottom: 0;
    height: 95%;
    overflow-y: scroll;
    /*overflow: auto;*/
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 180px;
}
.sidebar > ul {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue